
export { c as createAnalytics } from "./createAnalytics-f979bbf4.js"
export { i as plugins } from "./index-140d12f5.js"